<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_3"></a><strong>Four and Twenty<br/>Blackbirds</strong></h1>
<p class="author"><strong>CHERIE PRIEST</strong></p>
<p class="publisher"><img alt="pub" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4cdff02d